import {
  QuestionModel,
  QuestionType,
  ChoiceOption,
  LinkOption,
} from "hyer-flow-form";

import { SP, MG } from "../assets/estadosAtendidosParcialmente";

import validatorCNPJAndCPF from "../utils/validators/cnpjAndCpf";
import validateDataColeta from "../utils/validators/validateDataColeta";
import validateHoraAlmoco from "../utils/validators/validateHoraAlmoco";

export default [
  new QuestionModel({
    id: "solicitante",
    tagline:
      "Olá 👋, seja bem-vindo ao sistema de solicitação de coletas da TOCLOG! 🚚",
    title: "Qual é o seu nome?",
    type: QuestionType.Text,
    description:
      "⚠️ É importante que sua mercadoria e Nota Fiscal estejam prontas para a coleta.",
    required: true,
    placeholder: "Comece a digitar aqui...",
    validator: (value, questionModel) => {
      if (value.length < 3) {
        questionModel.description = "❌ Insira no mínimo 3 letras.";
        return false;
      }

      if (/[^A-Za-zÀ-ÿ\s]+/.test(value)) {
        questionModel.description = "❌ Insira somente letras.";
        return false;
      }

      if (value.length > 50) {
        questionModel.description = "❌ Insira no máximo 50 letras.";
        return false;
      }

      questionModel.description = "";
      return true;
    },
  }),
  new QuestionModel({
    id: "whatsAppSolicitanteColeta",
    tagline: "📲 E o zap? Vamos te manter informado por lá :)",
    title: "Qual é o seu WhatsApp?",
    type: QuestionType.Phone,
    required: true,
    mask: "(##) #####-####",
  }),
  new QuestionModel({
    id: "tipoPagadorFrete",
    tagline: "💸💵💰",
    title: "Quem é o PAGADOR do frete?",
    type: QuestionType.MultipleChoice,
    multiple: false,
    placeholder: "Selecione",
    helpTextShow: false,
    inline: false,
    required: true,
    options: [
      new ChoiceOption({
        label: "Remetente",
        value: "remetente",
      }),
      new ChoiceOption({
        label: "Destinatário",
        value: "destinatario",
      }),
    ],
    jump: {
      remetente: "cpfOrCnpjRemetente",
      destinatario: "cpfOrCnpjDestinatario",
    },
  }),
  new QuestionModel({
    id: "cpfOrCnpjRemetente",
    title: "Qual é o CPF/CNPJ do remetente?",
    type: QuestionType.Phone,
    required: true,
    validator: validatorCNPJAndCPF,
    mask: ["###.###.###-##", "##.###.###/####-##"],
    placeholder: "Comece a digitar...",
    jump: {
      _other: "estadoDestino",
    },
  }),
  new QuestionModel({
    id: "cpfOrCnpjDestinatario",
    title: "Qual é o CPF/CNPJ do destinatário?",
    type: QuestionType.Phone,
    required: true,
    validator: validatorCNPJAndCPF,
    mask: ["###.###.###-##", "##.###.###/####-##"],
    placeholder: "Comece a digitar...",
    jump: {
      _other: "cpfOrCnpjRemetente",
    },
  }),
  new QuestionModel({
    id: "estadoDestino",
    tagline: "Atendemos 100% dos Estados: GO, MA, PA, TO",
    title: "Qual é o Estado destino?",
    placeholder: "Selecione o Estado",
    type: QuestionType.Dropdown,
    required: true,
    options: [
      new ChoiceOption({
        label: "Goiás (GO)",
        value: "GO",
      }),
      new ChoiceOption({
        label: "Maranhão (MA)",
        value: "MA",
      }),
      new ChoiceOption({
        label: "Minas Gerais (MG)",
        value: "MG",
      }),
      new ChoiceOption({
        label: "Pará (PA)",
        value: "PA",
      }),
      new ChoiceOption({
        label: "São Paulo (SP)",
        value: "SP",
      }),
      new ChoiceOption({
        label: "Tocantins (TO)",
        value: "TO",
      }),
    ],
    jump: {
      GO: "cepEntrega",
      MA: "cepEntrega",
      PA: "cepEntrega",
      TO: "cepEntrega",
      SP: "cidadeDestinoSP",
      MG: "cidadeDestinoMG",
    },
  }),
  new QuestionModel({
    id: "cepEntrega",
    title: "Qual é o CEP do local de entrega?",
    type: QuestionType.Phone,
    required: true,
    mask: "#####-###",
    description: "💡 Dica: Descubra o seu CEP clicando aqui 👉",
    descriptionLink: [
      new LinkOption({
        url:
          "https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php",
        text: "Encontrar meu CEP",
        target: "_blank",
      }),
    ],
    validator: (value, questionModel) => {
      const parsedValue = value.replace("-", "");

      if (parsedValue.length !== 8) {
        questionModel.description = "❌ Insira 8 dígitos!";
        return false;
      }

      questionModel.description = "";
      return true;
    },
    jump: {
      _other: "qtdVolumes",
    },
  }),
  new QuestionModel({
    id: "cidadeDestinoSP",
    tagline: "Onde fica em São Paulo? 🤔",
    title: "Qual é a cidade destino da mercadoria?",
    type: QuestionType.Dropdown,
    placeholder: "Selecione uma cidade que já atendemos",
    required: true,
    options: SP.map(
      (city) =>
        new ChoiceOption({
          label: city.cidade,
          value: city.cidade,
        })
    ),
    jump: {
      _other: "valorMercadoria",
    },
  }),
  new QuestionModel({
    id: "cidadeDestinoMG",
    tagline: "Onde fica em Minas Gerais? 🤔",
    title: "Qual é a cidade destino da mercadoria?",
    type: QuestionType.Dropdown,
    placeholder: "Selecione uma cidade que já atendemos",
    required: true,
    options: MG.map(
      (city) =>
        new ChoiceOption({
          label: city.cidade,
          value: city.cidade,
        })
    ),
  }),
  new QuestionModel({
    id: "valorMercadoria",
    tagline: "💰🤑",
    title: "Qual é o valor da nota fiscal?",
    description: "⚠️ Essa informação garante o seguro da sua carga.",
    placeholder: "1500.00",
    type: QuestionType.Number,
    required: true,
    validator: (value, questionModel) => {
      if (value <= 0 || value > 1000000000) {
        questionModel.description =
          "❌ Valor do produto inválido.";
        return false;
      }

      questionModel.description = "";
      return true;
    },
  }),
  new QuestionModel({
    id: "qtdVolumes",
    title: "Quantidade total de volumes?",
    placeholder: "10",
    type: QuestionType.Number,
    required: true,
    validator: (value, questionModel) => {
      if (value > 100) {
        questionModel.description = "❌ É permitido no máximo 100 volumes.";
        return false;
      }

      questionModel.description = "";
      return true;
    },
  }),
  new QuestionModel({
    id: "pesoTotalCarga",
    tagline: "📦",
    title: "Peso total da carga? (em Kg)",
    description: "💡 Dica: informe apenas o número",
    placeholder: "10.5",
    type: QuestionType.Number,
    required: true,
    validator: (value, questionModel) => {
      if (value > 20000) {
        questionModel.description =
          "❌ O peso máximo permitido é de 20 toneladas (20000 Kg).";
        return false;
      }

      questionModel.description = "";
      return true;
    },
  }),
  new QuestionModel({
    id: "tipoMercadoria",
    tagline: "Caixa 📦; Tambor 🛢️; Vidro; Perfil...",
    title: "Qual o tipo de mercadoria?",
    type: QuestionType.Text,
    required: false,
    placeholder: "Descreva a mercadoria...",
    validator: (value, questionModel) => {
      if (value && value.length > 15) {
        questionModel.description = "❌ Insira no máximo 15 caracteres.";
        return false;
      }

      questionModel.description = "";
      return true;
    },
  }),
  new QuestionModel({
    id: "dimensoesMaiorMercadoria",
    tagline: "📦📏",
    title: "Sua mercadoria é maior do que 3 metros?",
    type: QuestionType.MultipleChoice,
    required: true,
    options: [
      new ChoiceOption({
        label: "Sim",
        value: true,
      }),
      new ChoiceOption({
        label: "Não",
        value: false,
      }),
    ],
  }),
  new QuestionModel({
    id: "limiteColeta",
    title: "Qual é o dia e horário limite para irmos coletar?",
    description: "💡 Dica: Digite APENAS NÚMEROS!",
    placeholder: "DD/MM até 18:00 hrs",
    type: QuestionType.Phone,
    required: true,
    mask: "##/## - ##:##",
    validator: validateDataColeta,
  }),
  new QuestionModel({
    id: "fechaAlmoco",
    tagline: "🍔🍕🍱😋",
    title: "O local da coleta fecha para o almoço?",
    helpTextShow: false,
    type: QuestionType.MultipleChoice,
    multiple: false,
    required: true,
    options: [
      new ChoiceOption({
        label: "Sim",
        value: "sim",
      }),
      new ChoiceOption({
        label: "Não",
        value: "nao",
      }),
    ],
    jump: {
      sim: "horarioAlmoco",
      nao: "pontoReferencia",
    },
  }),
  new QuestionModel({
    id: "horarioAlmoco",
    tagline: "🕒⏳",
    title: "Qual é o horário do almoço?",
    placeholder: "12:00 - 14:00",
    description: "💡 Dica: Digite APENAS NÚMEROS!",
    type: QuestionType.Phone,
    required: true,
    mask: "##:## - ##:##",
    validator: validateHoraAlmoco,
  }),
  new QuestionModel({
    id: "pontoReferencia",
    tagline: "🏢📍 Isso nos ajuda demais a garantir sua coleta",
    title: "Informe um ponto de referência",
    type: QuestionType.Text,
    required: false,
    placeholder: "Ao lado da...",
  }),
  new QuestionModel({
    id: "observacao",
    tagline: "📝",
    title: "Deixe registrado uma mensagem para os nossos coletadores 👷🚚",
    type: QuestionType.Text,
    placeholder: "Comece a escrever...",
    description: "💡 Exemplo: Quem devemos procurar no local?",
    required: false,
    jump: {
      _other: "_submit",
    },
  }),
];
